"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.palettes = void 0;
var echPaletteColorBlind = {
    colors: [
        '#54B399',
        '#6092C0',
        '#D36086',
        '#9170B8',
        '#CA8EAE',
        '#D6BF57',
        '#B9A888',
        '#DA8B45',
        '#AA6556',
        '#E7664C',
    ],
};
var echPaletteForLightBackground = {
    colors: ['#006BB4', '#017D73', '#F5A700', '#BD271E', '#DD0A73'],
};
var echPaletteForDarkBackground = {
    colors: ['#1BA9F5', '#7DE2D1', '#F990C0', '#F66', '#FFCE7A'],
};
var echPaletteForStatus = {
    colors: [
        '#209280',
        '#359F8A',
        '#4AAC94',
        '#6EB58C',
        '#A2BA71',
        '#DD9B53',
        '#E4784E',
        '#E2634A',
        '#D75C46',
        '#CC5642',
    ],
};
exports.palettes = {
    echPaletteColorBlind: echPaletteColorBlind,
    echPaletteForLightBackground: echPaletteForLightBackground,
    echPaletteForDarkBackground: echPaletteForDarkBackground,
    echPaletteForStatus: echPaletteForStatus,
};
//# sourceMappingURL=colors.js.map